import Accordion from './Accordion';
import AccordionImage from './AccordionImage';
import Badges from './Badges';
import CTA from './CTA';
import Divider from './Divider';
import ImageModule from './ImageModule';
import InfoBox from './InfoBox';
import LongCopyImage from './LongCopyImage';
import ModuleGroup from './ModuleGroup';
import PageHeading from './PageHeading';
import PageIndex from './PageIndex';
import PlainText from './PlainText';
import ShortCopyImage from './ShortCopyImage';
import VideoTab from './VideoTab';

export const PageModules = {
    Accordion,
    AccordionImage,
    Badges,
    CTA,
    Divider,
    Image: ImageModule,
    InfoBox,
    LongCopyImage,
    ModuleGroup,
    PageHeading,
    PageIndex,
    PlainText,
    ShortCopyImage,
    VideoTab
};

export const GroupModules = {
    Accordion,
    AccordionImage,
    Badges,
    CTA,
    Divider,
    Image: ImageModule,
    InfoBox,
    LongCopyImage,
    PageHeading,
    PageIndex,
    PlainText,
    ShortCopyImage
};